// TEMP Vietnam project access, see ./projectAccess.js. Kept free of Apollo client imports so the
// app shell (nav, route guard) can use it without an import cycle through src/index.jsx.
import { ROLE_HEADQUARTERS } from '../../../data/roles';

export const PROJECT_ACCESS_PATH = '/settings/project_access';

// HQ only. The backend enforces the same rule (pkg/projectaccess CanManage).
export const canManageProjectAccess = (role, features) => Boolean(features?.projectAccess)
  && role === ROLE_HEADQUARTERS;
